<template>
  <div class="body-inner">
    <div class="trending-bar hidden-xs">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h3 class="trending-title">Dernières actualités</h3>
            <div id="trending-slide" class="owl-carousel owl-theme trending-slide">
              <div class="item" v-for="article in lastArticles">
                <div class="post-content">
                  <h2 class="post-title title-small">
                    <router-link :to="{ name: 'ArticlePage', params: { slug: article.slug, id: article.oid } }">
                      {{ article.title }}
                    </router-link>
                  </h2>
                </div><!-- Post content end -->
              </div>
            </div><!-- Carousel end -->
          </div><!-- Col end -->
        </div><!--/ Row end -->
      </div><!--/ Container end -->
    </div><!--/ Trending end -->

    <div id="top-bar" class="top-bar">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-sm-8 col-xs-12"></div>
          <div class="col-md-4 col-sm-4 col-xs-12 top-social text-right">
            <ul class="unstyled">
              <li>
                <a title="Facebook" href="https://www.facebook.com/sharer/sharer.php" target="_blank">
                  <span class="social-icon"><i class="fa fa-facebook"></i></span>
                </a>
                <a title="Twitter" :href="`https://twitter.com/home?status=${pageUrl}`" target="_blank">
                  <span class="social-icon"><i class="fa fa-twitter"></i></span>
                </a>
                <a title="Google+" :href="`https://plus.google.com/share?url=${pageUrl}`" target="_blank">
                  <span class="social-icon"><i class="fa fa-google-plus"></i></span>
                </a>
                <a title="Linkdin" :href="`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`" target="_blank">
                  <span class="social-icon"><i class="fa fa-linkedin"></i></span>
                </a>
                <a title="Rss" :href="websiteRSS" target="_blank">
                  <span class="social-icon"><i class="fa fa-rss"></i></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <header id="header" class="header">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-5 col-md-4">
            <div class="logo text-left">
              <router-link :to="{ name: 'LastArticles' }">
                <h1 class="logo-text">{{ websiteName }}</h1>
              </router-link>
            </div>
          </div><!-- logo col end -->

          <div class="col-xs-12 col-sm-7 col-md-8 header-right">
            <div class="ad-banner pull-right">
              <ad format="header"></ad>
            </div>
          </div><!-- header right end -->
        </div><!-- Row end -->
      </div><!-- Logo and banner area end -->
    </header><!--/ Header end -->

    <div class="main-nav clearfix">
      <div class="container">
        <div class="row">
          <nav class="site-navigation navigation">
            <div class="site-nav-inner pull-left">
              <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse" id="mobile-menu">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>

              <div class="collapse navbar-collapse navbar-responsive-collapse" id="mobile-menu-content">
                <ul class="nav navbar-nav">
                  <router-link
                    tag="li"
                    :to="{ name: 'ArticlesForCategory', params: { category: websiteCategory, categoryValue: index + 1 } }"
                    v-for="(category, index) in getCategories(websiteCategory).slice(0, 4)"
                    :key="index + 1"
                  >
                    <a href="#">{{ category }}</a>
                  </router-link>
                  <li class="dropdown" id="dropdown-menu-plus">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown" id="dropdown-menu-button">Plus <i class="fa fa-angle-down"></i></a>
                    <ul class="dropdown-menu" role="menu">
                      <router-link
                        tag="li"
                        :to="{ name: 'ArticlesForCategory', params: { category: websiteCategory, categoryValue: index + 5 } }"
                        v-for="(category, index) in getCategories(websiteCategory).slice(4, 24)"
                        :key="index + 5"
                      >
                        <a href="#">{{ category }}</a>
                      </router-link>
                    </ul>
                  </li>
                </ul>
              </div><!--/ Collapse end -->

            </div><!-- Site Navbar inner end -->
          </nav><!--/ Navigation end -->

          <div class="nav-search">
            <span id="search"><i class="fa fa-search"></i></span>
          </div><!-- Search end -->

          <div class="search-block" style="display: none;">
            <form @submit.prevent="search">
              <input type="text" class="form-control" placeholder="Rechercher..." v-model="query">
            </form>
            <span class="search-close">&times;</span>
          </div><!-- Site search end -->

        </div><!--/ Row end -->
      </div><!--/ Container end -->

    </div><!-- Menu wrapper end -->

    <section class="block-wrapper p-bottom-0">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <router-view></router-view>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div class="sidebar sidebar-right">
              <div class="widget color-default">
                <h3 class="block-title"><span>Partage</span></h3>
                <ul class="social-icon text-center">
                  <li><a :href="websiteRSS" target="_blank"><i class="fa fa-rss"></i></a></li>
                  <li><a href="https://www.facebook.com/sharer/sharer.php" target="_blank"><i class="fa fa-facebook"></i></a></li>
                  <li><a :href="`https://twitter.com/home?status=${pageUrl}`" target="_blank"><i class="fa fa-twitter"></i></a></li>
                  <li><a :href="`https://plus.google.com/share?url=${pageUrl}`" target="_blank"><i class="fa fa-google-plus"></i></a></li>
                </ul>
              </div>
              <div class="widget m-bottom-0">
                <h3 class="block-title"><span>Newsletter</span></h3>
                <div class="ts-newsletter">
                  <div class="newsletter-introtext">
                    <h4>S'abonner</h4>
                    <p>Abonnez-vous pour recevoir les derniers actualités par e-mail</p>
                  </div>

                  <div class="newsletter-form">
                    <add-subscriber ref="addSubscriber" :broadcastChannel="broadcastChannel"></add-subscriber>
                    <form action="#" method="post" @submit.prevent="subscribeUser">
                      <div class="form-group">
                        <input type="email" name="email" id="newsletter-form-email" class="form-control full-width-input" placeholder="E-mail" autocomplete="off" v-model="email">
                        <p>
                          <router-link :to="{ name: 'RGPD' }">Voir la politique de confidentialité</router-link>
                        </p>
                        <button class="btn btn-primary">S'abonner</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <br />
              <div class="widget color-default" v-if="websiteSecondCategory">
                <h3 class="block-title"><span>Thèmes</span></h3>
                <router-link
                  :to="{ name: 'ArticlesForCategory', params: { category: websiteSecondCategory, categoryValue: index + 1 } }"
                  v-for="(category, index) in getCategories(websiteSecondCategory)"
                  :key="index + 1"
                  class="btn btn-default"
                >
                  {{ category }} &nbsp;
                </router-link>
              </div>
              <div class="widget color-default">
                <h3 class="block-title"><span>ITRTV</span></h3>
                <vimeo-videos :per_page="1">
                  <template slot-scope="props">
                    <article class="article-mini" v-for="video in props.videos">
                      <div class="inner">
                        <div>
                          <div v-html="video.iframeCode"></div>
                          <br />
                          <p class="text-center">
                            <a :href="video.link" target="_blank">{{ video.name }}</a>
                          </p>
                          <div class="text-center">
                            <a href="http://itrtv.com" target="_blank" class="btn btn-primary">Plus de vidéos sur ITRTV</a>
                          </div>
                        </div>
                      </div>
                    </article>
                  </template>
                </vimeo-videos>
              </div>
              <br /><br/>
              <div class="widget">
                <ad format="sidebar"></ad>
              </div>
              <div class="widget color-default">
                <h3 class="block-title"><span>Communiqués de presse</span></h3>
                    <press-releases :limit="10" :withFile="false">
                  <template slot-scope="props">
                    <ul class="list-post">
                      <li v-for="pressRelease in props.pressReleases">
                        <h2 class="post-title title-small">
                          <router-link :to="{ name: 'PressReleasePage', params: { id: pressRelease.id, slug: pressRelease.slug } }">{{ pressRelease.shortTitle }}</router-link>
                        </h2>
                      </li>
                    </ul>
                  </template>
                </press-releases>
              </div>
              <br /><br />
              <div class="widget">
                <ad format="card"></ad>
              </div>
              <br/><br/>
              <div class="widget color-default">
                <h3 class="block-title"><span>Derniers commentaires</span></h3>
                <last-comments :tag="websiteTags[0]">
                  <template slot-scope="props">
                    <ul class="list-post">
                      <li v-for="comment in props.comments">
                        <router-link :to="{ name: 'ArticlePage', params: { slug: comment.slug, id: comment.oid } }">
                          {{ comment.title }}
                        </router-link>&nbsp;&nbsp;Par {{ comment.author_name }} le {{ comment.date }}<br />
                        <br />
                      </li>
                    </ul>
                  </template>
                </last-comments>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <br /><br />
    <section class="block-wrapper video-block">
      <div class="container">
        <div class="row">
          <div class="video-tab clearfix">
            <h2 class="video-tab-title">ITRTV</h2>
            <div class="row">
              <vimeo-widget></vimeo-widget>
            </div>
          </div>
        </div>
      </div>
    </section>
    <br /><br />
        <ad format="header"></ad>
    <br />

    <footer id="footer" class="footer">
      <div class="footer-main">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-sm-12 footer-widget twitter-widget">
              <h3 class="widget-title">Contact</h3>
              <p>
                <strong>{{ websiteName }}</strong><br/>
                Carré des Archives<br />
                75 rue des Archives<br />
                75003 Paris
              </p>
              <p>
                <strong>Pour nous contacter :</strong><br />
                Tél : 01 40 16 10 77
              </p>
              <p>
                <strong>Publicité</strong><br />
                Tèl : 01 40 16 18 48<br />
                Fax : 01 49 95 00 23<br />
                <a :href="`mailto:publicite@${websiteUrl}`">Contactez nous par mail</a>
              </p>
              <p>
                <strong>Rédaction</strong><br />
                Tél : 01 40 16 18 55<br />
                <a :href="`mailto:redaction@${websiteUrl}`">Contactez nous par mail</a>
              </p>
            </div><!-- Col end -->
            <div class="col-md-6 col-sm-12 footer-widget">
              <h3 class="widget-title">Derniers articles</h3>
              <div class="list-post-block">
                <articles-query :tags="[websiteCategory]" :limit="5" :withPagination="false" @onArticlesLoaded="setLastArticles">
                </articles-query>
                <ul class="list-post">
                  <li class="clearfix" v-for="article in lastArticles">
                    <div class="post-block-style post-float clearfix">
                      <div class="post-thumb" v-if="article.featured_img">
                        <router-link :to="{ name: 'ArticlePage', params: { slug: article.slug, id: article.oid } }">
                          <img class="img-responsive" :src="article.featured_img" />
                        </router-link>
                      </div><!-- Post thumb end -->

                      <div class="post-content">
                        <h2 class="post-title title-small">
                          <router-link :to="{ name: 'ArticlePage', params: { slug: article.slug, id: article.oid } }">
                            {{ article.shortTitle }}
                          </router-link>
                        </h2>
                        <div class="post-meta">
                          <span class="post-date">{{ article.date }}</span>
                        </div>
                      </div><!-- Post content end -->
                    </div><!-- Post block style end -->
                  </li>
                </ul><!-- List post end -->
              </div><!-- List post block end -->

            </div><!-- Col end -->

            <div class="col-md-3 col-sm-12 footer-widget widget-categories">
              <h3 class="widget-title">Catégories populaires</h3>
              <ul>
                <li v-for="(value, tag) in tags">
                  <router-link :to="{ name: 'ArticlesForCategory', params: { category: websiteCategory, categoryValue: value } }">
                    <span class="catTitle">{{ tag }}</span>
                  </router-link>
                </li>
              </ul>

            </div><!-- Col end -->
          </div><!-- Row end -->
        </div><!-- Container end -->
      </div><!-- Footer main end -->

      <div class="footer-info text-center">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="footer-info-content">
                <site-footer></site-footer>
                <br /><br />
                <p class="text-center">
                  <router-link :to="{ name: 'RGPD' }">Voir la politique de confidentialité</router-link>
                </p>
                <br/>
                <span>Copyright © 2017 {{ websiteName }} Tous droits réservés</span>
              </div><!-- Footer info content end -->
            </div><!-- Col end -->
          </div><!-- Row end -->
        </div><!-- Container end -->
      </div><!-- Footer info end -->
    </footer><!-- Footer end -->
  </div>
</template>

<script>
  import { Ad, AddSubscriber, ArticlesQuery, categories, SiteFooter, PressReleases, VimeoWidget, VimeoVideos, TopArticles, LastComments } from 'itrnews-vuejs-api';
  import website from './mixins/website';

  export default {
    name: 'app',
    components: {
      Ad, ArticlesQuery, AddSubscriber, SiteFooter, PressReleases, VimeoWidget, VimeoVideos, TopArticles, LastComments, // eslint-disable-line
    },
    mixins: [website, categories],
    methods: {
      subscribeUser(event) {
        event.preventDefault();
        this.$refs.addSubscriber.sendRequest(this.email);
      },
      setLastArticles(articles) {
        this.lastArticles = articles;
        setTimeout(() => {
          $('.trending-slide').owlCarousel({
            loop: true,
            animateIn: 'fadeIn',
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            nav: true,
            margin: 30,
            dots: false,
            mouseDrag: false,
            slideSpeed: 500,
            navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            items: 1,
            responsive: { 0: { items: 1 }, 600: { items: 1 } },
          });
        }, 500);
      },
      search(event) {
        event.preventDefault();
        $('.search-block').fadeOut(350);
        this.$router.push({ name: 'ArticlesSearch', params: { query: this.query } });
      },
    },
    mounted() {
      this.pageUrl = window.location.href;
      this.getCategories(this.websiteCategory).slice(0, 4).forEach((category, index) => {
        this.$set(this.tags, category, index + 1);
      });
    },
    data() {
      return {
        pageUrl: '',
        email: '',
        query: '',
        tags: {},
        lastArticles: [],
      };
    },
  };
</script>

<style>
  .post-block-style.post-float-half .post-thumb img {
    min-width: 200px!important;
    max-height: 400px;
    min-height: inherit;
  }
  section.block-wrapper.video-block h4 {
    color: white;
  }
  .video-tab-title {
    text-align: center;
    font-size: 30px;
  }
  .full-width-input {
    min-width: 100% !important;;
  }
  .logo-text {
    font-size: 68px;
  }
  @media screen and (max-width: 1200px) {
    .logo-text {
      font-size: 55px !important;
    }
  }
  ins {
    text-decoration: none;
  }
  .color-originalRed .block-title > span {
    background-color: #F44336;
  }
  .color-originalRed .block-title > span:after {
    border-color: #F44336 rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);
  }
  .color-originalRed .block-title {
    border-bottom: 2px solid #F44336;
  }
  .form-control:focus {
    box-shadow: none;
    border: 1px solid #333;
  }
  .single-post p {
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue